import React from "react";
import { Link } from "react-router-dom";

const BirthdayCard = ({ data }) => {
  const birthdays = data?.todays_birthday_list || [];

  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div
        className="card text-white"
        style={{
          background: "linear-gradient(135deg, #1A4331 0%, #2e6e4f 100%)",
          borderRadius: "16px",
          height: "280px",
          position: "relative",
          overflow: "hidden",
          boxShadow: "0 6px 16px rgba(26, 67, 49, 0.25)",
        }}
      >
        {/* Professional Top Right Wave Shape */}
        <svg
          width="200"
          height="150"
          viewBox="0 0 200 150"
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            zIndex: 0,
          }}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M200 0H50C80 30 120 40 140 70C160 100 170 130 200 150V0Z"
            fill="rgba(255,255,255,0.08)"
          />
          <path
            d="M200 0H0C40 20 80 50 120 50C160 50 180 90 200 110V0Z"
            fill="rgba(255,255,255,0.05)"
          />
        </svg>

        <style>
          {`
            @keyframes balloonFloatUp {
              0% { top: 100%; transform: translateX(0) rotate(0deg); opacity: 0; }
              10% { opacity: 0.15; }
              50% { transform: translateX(15px) rotate(5deg); }
              90% { opacity: 0.15; }
              100% { top: -30%; transform: translateX(-15px) rotate(-5deg); opacity: 0; }
            }
            .balloon-anim {
              position: absolute;
              opacity: 0;
              pointer-events: none;
              animation: balloonFloatUp 8s linear infinite;
            }
            .b1 { left: 10%; width: 60px; animation-duration: 10s; animation-delay: 0s; }
            .b2 { left: 35%; width: 45px; animation-duration: 8s; animation-delay: 3s; }
            .b3 { left: 65%; width: 70px; animation-duration: 12s; animation-delay: 1s; }
            .b4 { left: 85%; width: 40px; animation-duration: 7s; animation-delay: 5s; }
            .b5 { left: 20%; width: 55px; animation-duration: 11s; animation-delay: 6s; }
            .b6 { left: 75%; width: 50px; animation-duration: 9s; animation-delay: 2.5s; }
          `}
        </style>

        {/* Center Background Graphic (Balloons) */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 0,
            pointerEvents: "none",
          }}
        >
          {[...Array(6)].map((_, idx) => (
            <svg
              key={idx}
              className={`balloon-anim b${idx + 1}`}
              viewBox="0 0 24 45"
              fill="none"
              stroke="#ffffff"
              strokeWidth="0.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path
                d="M12 2 C7 2, 4 6, 4 12 C4 18, 10 23, 12 25 C14 23, 20 18, 20 12 C20 6, 17 2, 12 2 Z"
                fill="rgba(255,255,255,0.06)"
              />
              <path
                d="M12 25 L10 28 L14 28 Z"
                fill="rgba(255,255,255,0.15)"
                stroke="none"
              />
              <path d="M12 28 C10 32, 14 36, 12 45" />
            </svg>
          ))}
        </div>

        <div className="card-body position-relative z-1 d-flex flex-column">
          <div style={{ fontSize: "2.5rem", marginBottom: "15px" }}>🎂</div>

          {birthdays.length > 0 ? (
            <>
              <div className="avatar-group d-flex align-items-center mb-4 flex-wrap">
                {birthdays.slice(0, 10).map((user, i) => (
                  <div
                    key={i}
                    className="avatar avatar-md pull-up"
                    title={`${user?.name || user?.company_name}`}
                    style={{
                      border: "2px solid #1A4331",
                      borderRadius: "50%",
                      cursor: "pointer",
                      width: "42px",
                      height: "42px",
                      marginLeft: i === 0 ? "0" : "-10px",
                    }}
                  >
                    <img
                      src={
                        user?.thumb_profile_image ||
                        user?.profile_image ||
                        "https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80"
                      }
                      alt="Avatar"
                      className="rounded-circle"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                ))}
                {birthdays.length > 10 && (
                  <div
                    className="avatar avatar-md d-flex align-items-center justify-content-center"
                    style={{
                      border: "2px solid #1A4331",
                      borderRadius: "50%",
                      width: "42px",
                      height: "42px",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      marginLeft: "-10px",
                      zIndex: 10,
                    }}
                  >
                    <span className="fw-bold text-white fs-6">
                      +{birthdays.length - 10}
                    </span>
                  </div>
                )}
              </div>

              <p
                style={{
                  color: "#ffd54f",
                  fontWeight: "600",
                  marginBottom: "4px",
                  fontSize: "0.9rem",
                }}
              >
                {birthdays.length} Birthday Budd
                {birthdays.length > 1 ? "ies" : "y"}
              </p>
              <h5 className="text-white mb-3" style={{ fontWeight: "700", fontSize: "1.3rem" }}>
                Wish Your Members!
              </h5>
            </>
          ) : (
            <div className="d-flex flex-column justify-content-center flex-grow-1 mt-2">
              <h4 className="text-white mb-2" style={{ fontWeight: "700" }}>
                No Birthdays Today!
              </h4>
              <p
                className="mb-0"
                style={{
                  color: "rgba(255,255,255,0.85)",
                  fontSize: "0.9rem",
                  lineHeight: "1.5",
                }}
              >
                Looks like it's a quiet day. Check back tomorrow to see if
                anyone is celebrating!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BirthdayCard;
